import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const RegisterExternal = (externalUser) => {
    return vdkHappinessPortalApi.post(`external/external-registration`, externalUser);
};
const GetByPerson = (request) => {
    return vdkHappinessPortalApi.post(`external/get-externals-by-company-and-personId`, request);
};
const GetExternalByUserId = (UserId) => {
    return vdkHappinessPortalApi.get(`external/${UserId}/get-external-by-userId`);
};
const DeleteExternalById = (Id) => {
    return vdkHappinessPortalApi.delete(`external/${Id}/delete-external-by-Id`);
};
const GetExternalCountPerCompany = (personId) => {
    return vdkHappinessPortalApi.get(`external/${personId}/get-external-count-per-company-by-personid`);
};
const ExternalApi = {
    RegisterExternal,
    GetByPerson,
    GetExternalByUserId,
    DeleteExternalById,
    GetExternalCountPerCompany,
};
export default ExternalApi;
